// src/data/books/FundamentosBlockchain/data/cap6.js
const BLOCKCHAIN_FUNDAMENTOS_CH06 = {
  id: "blockchain-fundamentos-6",
  slug: "origen-y-funcionamiento-de-bitcoin",
  contentId: 6,
  title: "Bitcoin: Origen, Funcionamiento de la Primera Criptomoneda",
  sections: [
    {
      id: "introduccion",
      heading: "El nacimiento de un nuevo sistema económico digital",
      text: `Bitcoin marcó el inicio de una nueva era en la economía global. 
Fue la primera criptomoneda en operar de forma ininterrumpida desde 2009, 
abriendo el camino hacia un modelo financiero sin intermediarios ni autoridades centrales. 
Más que una moneda digital, Bitcoin representa una combinación de tres elementos: 
un software de código abierto, un protocolo criptográfico y un sistema monetario basado en consenso distribuido.`
    },
    {
      id: "concepto",
      heading: "Un protocolo, un software y una moneda",
      text: `Bitcoin puede entenderse como la unión de tres conceptos complementarios. 
Como **software**, es un programa que ejecuta las reglas de validación y comunicación entre nodos. 
Como **protocolo**, define las normas mediante las cuales los participantes verifican transacciones y añaden nuevos bloques. 
Y como **moneda**, actúa como unidad digital de intercambio con valor determinado por la oferta, la demanda y la confianza de sus usuarios. 
Su diseño busca ofrecer un sistema de pagos transparente, abierto y global, en el que el dinero no dependa de bancos ni gobiernos, sino de la matemática y la criptografía.`
    },
    {
      id: "origen",
      heading: "El inicio: una idea revolucionaria",
      text: `El 31 de octubre de 2008 se publicó un documento titulado *“Bitcoin: A Peer-to-Peer Electronic Cash System”* firmado bajo el seudónimo **Satoshi Nakamoto**. 
Ese texto —conocido como el *whitepaper*— describía un sistema de dinero digital basado en una red descentralizada donde las transacciones se validaban entre iguales (*peer-to-peer*) sin intermediarios. 
El primer bloque, llamado **bloque génesis**, fue minado el 3 de enero de 2009, marcando el inicio oficial de la red Bitcoin. 
Desde entonces, el sistema ha funcionado sin interrupciones, demostrando la solidez de su arquitectura y del modelo de consenso en el que se basa.`
    },
    {
      id: "mineria",
      heading: "Creación de bitcoins y mecanismo de minería",
      text: `La emisión de nuevos bitcoins sigue un proceso predecible y transparente. 
Cada bloque se genera aproximadamente cada diez minutos y contiene un conjunto de transacciones validadas. 
El sistema recompensa a los mineros —los nodos que aportan poder de cómputo para resolver los problemas criptográficos— con una cantidad determinada de bitcoins por bloque creado. 
Esta recompensa se reduce a la mitad cada **210 000 bloques**, fenómeno conocido como *halving*. 
Debido a este diseño, el número total de bitcoins que existirán está limitado a **21 millones**, cifra que se alcanzará alrededor del año 2140.`
    },
    {
      id: "prueba-de-trabajo",
      heading: "Proof of Work: el corazón del consenso",
      text: `Bitcoin utiliza un algoritmo de consenso denominado **Proof of Work (Prueba de Trabajo)**. 
Este mecanismo garantiza que la validación de cada bloque requiera un esfuerzo computacional real, lo que hace extremadamente costoso alterar el historial de transacciones. 
La red premia a los mineros que encuentran la solución correcta con nuevas monedas y las tarifas de transacción asociadas al bloque. 
Gracias a este sistema, la seguridad de Bitcoin no depende de la confianza en una entidad, sino del poder colectivo de miles de equipos distribuidos en todo el mundo.`
    },
    {
      id: "referencia-mercado",
      heading: "Bitcoin como referencia del mercado cripto",
      text: `Por ser la primera criptomoneda funcional, Bitcoin se convirtió en el activo de referencia de todo el ecosistema. 
Casi todas las monedas digitales existentes se intercambian en función de su valor respecto a BTC, y los precios suelen expresarse también en dólares estadounidenses o euros. 
Su dominio ha convertido a Bitcoin en una métrica fundamental para medir la salud y evolución del mercado cripto en general.`
    },
    {
      id: "primeras-transacciones",
      heading: "De la teoría a la práctica: las primeras transacciones",
      text: `Las primeras operaciones con Bitcoin se centraron en la experimentación. 
El caso más emblemático ocurrió el **22 de mayo de 2010**, cuando el programador **Laszlo Hanyecz** compró dos pizzas por **10 000 BTC**, equivalentes en aquel momento a unos 80 dólares. 
Esa fecha pasó a conocerse como el *Bitcoin Pizza Day*, un símbolo del crecimiento exponencial que ha tenido el valor de la criptomoneda, ya que esos mismos bitcoins hoy valdrían cientos de millones de dólares.`
    },
    {
      id: "impacto-y-controversia",
      heading: "Impacto global y debates regulatorios",
      text: `El ascenso de Bitcoin provocó intensos debates en los sectores financieros y gubernamentales. 
Su naturaleza descentralizada desafía el control tradicional de la emisión de dinero y el monopolio de los bancos centrales. 
Mientras unos lo ven como una amenaza al sistema financiero establecido, otros lo consideran una oportunidad para fomentar la inclusión económica y la innovación tecnológica. 
En la actualidad, diversos países trabajan en marcos regulatorios que permitan equilibrar la libertad financiera que ofrece Bitcoin con las necesidades de supervisión fiscal y prevención del fraude.`
    },
    {
      id: "legado",
      heading: "Legado y evolución del ecosistema",
      text: `Más allá de su valor económico, Bitcoin sentó las bases para una nueva generación de tecnologías y modelos de negocio. 
Inspiró la creación de miles de criptomonedas y de plataformas basadas en blockchain que hoy impulsan sectores tan diversos como las finanzas descentralizadas (DeFi), la tokenización de activos, los NFTs o los sistemas de identidad digital. 
En poco más de una década, pasó de ser un experimento entre programadores a convertirse en un fenómeno global que redefine la noción misma de confianza en la era digital.`
    },
    
  ]
};

export default BLOCKCHAIN_FUNDAMENTOS_CH06;
